// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__31_ad","label":"styles_label__Ht8oU","icon":"styles_icon__YULCN"};